import React from 'react';

import { useIntl } from 'react-intl';

import Currency from 'components/currency';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { useLocale } from 'state/intl';
import { REGIONS } from 'state/intl/types';

import { Total, TotalLabel, TotalsRow } from './styled';

const TaxesRow: React.FC<{ taxCents: number; isLoading?: boolean }> = ({ taxCents, isLoading }) => {
  const { region } = useLocale();
  const { formatMessage } = useIntl();

  if (region === REGIONS.GB) {
    return null;
  }

  return (
    <TotalsRow>
      {isLoading ? (
        <CurrencyLineSkeleton />
      ) : (
        <>
          <TotalLabel>
            {formatMessage({
              id: 'tax',
            })}
          </TotalLabel>
          <Total data-testid="totalTax">
            <Currency amount={taxCents} />
          </Total>
        </>
      )}
    </TotalsRow>
  );
};

export default TaxesRow;
